export enum GlobalPickerPerformType {
  ConfirmSeparation = 1
}